import React from 'react';
import { motion } from 'framer-motion';
import { AppStoreButton } from './AppStoreButton';
import { PlayStoreButton } from './PlayStoreButton';
export function CtaSection() {
  return <section className="bg-black py-24 px-6" data-id="element-17" data-mp="h2ose5iklsr6">
      <div className="max-w-4xl mx-auto text-center" data-id="element-18" data-mp="h0u5wmrnhskz">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} data-id="element-19" data-mp="m18i8h0aboot">
          <h2 className="text-4xl md:text-6xl font-black text-white mb-10 leading-tight" data-id="element-20" data-mp="zseoqx1zeml7">
            Start creating music today
          </h2>

          <div className="flex flex-wrap items-center justify-center gap-3 mb-14" data-id="element-21" data-mp="14r7z4glz1xh5">
            <AppStoreButton className="ring-1 ring-white/20" data-id="element-22" data-mp="19snm4e7pme26" />
            <PlayStoreButton className="ring-1 ring-white/20" data-id="element-23" data-mp="1epnu4uo4dqvx" />
          </div>
        </motion.div>

        <div className="flex items-center justify-center gap-4 mb-3" data-id="element-24" data-mp="3nab185udbv70">
          <a href="https://go.pixo.co/croon-terms" target="_blank" rel="noopener noreferrer" className="text-white/50 hover:text-white/80 text-sm font-medium transition-colors" data-id="element-25" data-mp="3n7f4gku9bck5">
            Privacy
          </a>
          <span className="text-white/20" data-id="element-26" data-mp="39bl6gwv0u7lt">·</span>
          <a href="https://go.pixo.co/croon-privacy" target="_blank" rel="noopener noreferrer" className="text-white/50 hover:text-white/80 text-sm font-medium transition-colors" data-id="element-27" data-mp="9vep0x5y5pun">
            Terms
          </a>
          <span className="text-white/20" data-id="element-28" data-mp="2peq5m4ui0w">·</span>
          <a href="mailto:support@pixo.co" className="text-white/50 hover:text-white/80 text-sm font-medium transition-colors" data-id="element-29" data-mp="3s7tcw3zrsoip">
            Contact Support
          </a>
        </div>
        <div className="text-white/30 text-sm font-medium" data-id="element-30" data-mp="nt3b28br331a">
          © {new Date().getFullYear()} Croon. All rights reserved.
        </div>
      </div>
    </section>;
}